module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/025-anguilla-242690eadc9bc996ac88840460c26121.svg";